<template>
    <div id="app">
        <b-navbar toggleable="lg" type="dark" variant="dark" style="margin-bottom: 20px">
            <b-navbar-brand href="#" @click="$router.push('/')">
                Drop
            </b-navbar-brand>

            <a class="brand-logo" v-if="$globalStore.authed || $router.currentRoute.path.startsWith('/upload/')">
                <img src="https://drop.rautec.de/static/company_logo_small.png" alt="RAUTEC GmbH" width="80" height="40">
            </a>

            <b-navbar-toggle target="nav_collapse" />

            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item v-if="$globalStore.authed" @click="$router.push('/files')">{{ 'navbar.files' | translate }}</b-nav-item>
                    <b-nav-item v-if="$globalStore.authed && ($globalStore.group === 1 || $globalStore.group === 2)" @click="$router.push('/users')">{{ 'navbar.users' | translate }}</b-nav-item>
                    <b-nav-item v-if="$globalStore.authed && ($globalStore.group === 1 || $globalStore.group === 2)" @click="$router.push('/projectGroups')">{{ 'navbar.project.groups' | translate }}</b-nav-item>
                    <b-nav-item v-if="$globalStore.authed && ($globalStore.group === 1 || $globalStore.group === 2)" @click="$router.push('/tmpUpload')">{{ 'navbar.upload.tmp' | translate }}</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-if="$globalStore.authed && $globalStore.group === 1" @click="$router.push('/settings')">{{ 'navbar.settings' | translate }}</b-nav-item>
                    <b-nav-item v-if="$globalStore.authed" @click="$router.push('/profile')">{{ 'navbar.profile' | translate }}</b-nav-item>
                    <b-nav-item v-if="$globalStore.authed" @click="$router.push('/logout')">{{ 'navbar.logout' | translate }} ({{ $globalStore.lastName }})</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div id="body">
            <router-view/>
        </div>

        <div id="footer">
            <div class="navbar navbar-default navbar-fixed-bottom footer">
                <div class="align-content-center">
                    <ul class="footer-items">
                        <li>
                            <a href="https://www.rautec.de/impressum">{{ 'footer.imprint' | translate }}</a>
                        </li>
                        <li class="footer-items-separator">
                            |
                        </li>
                        <li>
                            <a href="https://www.rautec.de/datenschutz">{{ 'footer.privacy' | translate }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'App',
        methods: {
            checkInitialAuthState: function () {
                axios.get('https://drop.rautec.de/api/auth/check').then(response => {
                    this.$globalStore.authed = true;
                    this.$globalStore.group = response.data.group;
                    this.$globalStore.lastName = response.data.lastName;

                    // Respect the language the user has set in the profile
                    this.$globalStore.loadTranslation(response.data.language);

                    if (this.$router.currentRoute.path === '/') {
                        this.$router.push('/home');
                    }
                }).catch(reason => {
                    this.$globalStore.authed = false;
                    this.$globalStore.group = 0;
                    this.$globalStore.lastName = '';
                });
            }
        },
        beforeMount() {
            // Use the browser language first, to handle the case where a client visits the download route
            // This will get overridden above for logged in users, to respect their chosen profile language
            let userLang = navigator.language || navigator.userLanguage;

            this.$globalStore.loadTranslation(userLang);
        },
        mounted() {
            this.checkInitialAuthState();
        }
    }
</script>

<style scoped>
    #app {
        position: relative;
        display: flex;
        min-height: 100vh;
        margin: 0 auto;
        flex-direction: column;
        padding-bottom: 8rem;
        font-size: 1rem;
    }

    #body {
        display: flex;
        flex-direction: column;
    }

    .brand-logo {
        position: absolute;
        left: 50%;
        margin-left: -50px;
        display: block;
        margin-top: 5px;
    }

    /* CSS hack to position the brand logo centered on internet explorer */
    /* Source: https://stackoverflow.com/questions/11173106/apply-style-only-on-ie */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        .brand-logo {
            position: absolute;
            left: 50%;
            margin-left: -50px;
            display: block;
            margin-top: -15px;
        }
    }

    #footer {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #343a40;
        z-index: 0;
    }

    .footer-items {
        height: 40px;
        justify-content: center;
        padding: 15px 0 0;
    }

    .footer-items-separator {
        margin-left: 8px;
        margin-right: 8px;
    }

    html {
        height: 100%;
    }

    ul {
        list-style-type: none;
        display: flex;
    }

    .navbar-default {
        background-color: #212121 !important;
        color: white !important;
        display: inherit;
    }

    .navbar-default .navbar-nav > li > a {
        color: white;
    }

    a {
        color: white !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue